<template>
  <div>
    <b-button
      variant="outline-primary"
      @click="openAdditionalFieldsModal"
    >
      <i
        class="fas fa-external-link-alt"
        aria-hidden="true"
      />
      {{ $t('reports.additional-fields') }}
    </b-button>
    <additional-fields-modal
      v-model="showModal"
      :tabs-to-show="tabsToShow"
      @confirm="emitSelectedFields"
    />
  </div>
</template>

<script>
import AdditionalFieldsModal
  from '@/domain/components/generalPanel/reports/additionalFields/modal/AdditionalFieldsModal';
import { AssetTypes } from 'sigma-mappings';

export default {
  name: 'AdditionalFields',
  props: {
    tabsToShow: {
      type: Array,
      default: () => ([
        AssetTypes.TRANSFORMER,
        AssetTypes.CIRCUIT_BREAKER,
        AssetTypes.DISCONNECTOR,
      ]),
    },
  },
  components: { AdditionalFieldsModal },
  data: () => ({
    showModal: false,
  }),
  methods: {
    openAdditionalFieldsModal() {
      this.showModal = true;
    },
    emitSelectedFields(value) {
      this.$emit('fields-selected', value);
    },
  },
};
</script>
